import styled, { css } from 'styled-components';
import { ServicesSubSectionContainer } from '../../services/services-subsection/services-subsection.styles';
import {
  FontSizes,
  TextBody as BodyText,
} from '../../../common/typography/typography.styles';
import { MenuItems } from '../../../common/menu-item/menu-item.styles';

export const ParcelParticipantDetailsContainer = styled(
  ServicesSubSectionContainer
)`
  .personal-form-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: var(--services-subsection-gap);

    > h2 {
      margin-bottom: 0;
    }
  }

  .contacts-button {
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 32px;
    padding: 4px 12px;
    border: 1px solid ${({ theme }) => theme.colors.namedColors.primary};
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.namedColors.white};
    color: ${({ theme }) => theme.colors.namedColors.primary};
    font-family: ${({ theme }) => theme.fonts.body.fontFamily};
    font-size: ${FontSizes.normal};
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.5px;
    white-space: nowrap;
    cursor: pointer;

    svg {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
    }

    &:focus-visible {
      outline: 2px solid ${({ theme }) => theme.colors.namedColors.primary};
      outline-offset: 2px;
    }
  }

  form {
    .inputs {
      flex-direction: column;
      gap: 2rem;
    }
  }
`;

interface FormInputsContainerProps {
  $isPassportLayout?: boolean;
}

export const FormInputsContainer = styled.div<FormInputsContainerProps>`
  display: grid;
  grid-template-columns: 1fr; // default: single column
  gap: 2rem;

  > * {
    grid-column: 1 / -1;
  }

  ${({ $isPassportLayout }) =>
    $isPassportLayout
      ? css`
          grid-template-columns: 1fr 1fr;

          > :nth-child(4) {
            grid-column: 1;
          }
          > :nth-child(5) {
            grid-column: 2;
          }
        `
      : undefined}

  @media (max-width: 650px) {
    gap: 1.6rem;
    grid-template-columns: 1fr;
    > :nth-child(5) {
      grid-column: 1;
    }
  }
`;

export const FormFieldContainer = styled.div`
  position: relative;
`;

export const FormFieldIcon = styled.div`
  svg {
    width: 20px;
    height: 20px;
  }

  button {
    padding: 0;
    color: ${({ theme }) => theme.colors.baseColors.grey100};
    &:hover,
    &:focus-visible {
      color: ${({ theme }) => theme.colors.namedColors.primary};
    }
  }
`;

export const MenuItemsReceivers = styled(MenuItems)`
  gap: 12px;
  padding-right: 6px;

  & button {
    border-radius: 12px;
    border: 1px solid
      ${({ theme }) => theme.colors.passwordValidationMarker.backgroundColor};
    background: ${({ theme }) => theme.colors.namedColors.white};
    padding: 16px;
    gap: 0;
  }

  & > div {
    padding: 0;
  }
`;

export const TextBody = styled(BodyText)`
  color: ${({ theme }) => theme.colors.baseColors.grey100};
  text-align: center;
`;

export const EmptyReceiversListContainer = styled.div`
  margin: auto 0;
  display: grid;
  justify-items: center;
  gap: 32px;
  text-align: center;
`;

export const EmptyReceiversListIconWrapper = styled.div`
  max-width: 145px;
  svg {
    width: 100%;
    height: 100%;
  }
`;
